import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse, IServiceResponse } from '@/data/models/ServiceResponse'

export class DrillApiService extends ApiService {
  static async getPaginated(query: object): Promise<IPaginatedServiceResponse<object>> {
    return this.axios.get('drills', { params: query })
      .then((response: AxiosResponse<IPaginatedServiceResponse<object>>) => response.data)
  }

  static async getAll(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('drills', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async create(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('drills', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async update(drillId: string, data: object): Promise<IServiceResponse<object>> {
    return this.axios.put(`drills/${drillId}`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async delete(drillId: string): Promise<AxiosResponse> {
    return this.axios.delete(`drills/${drillId}`)
  }
}
